/**
 * ConsentCountdown (Phase 2, §7.5) — "läuft in {n} Tagen ab". Renders nothing
 * when `days` is null (no consent yet / revoked). Turns red at ≤14 days, the
 * same T-14d threshold at which the backend sends the re-consent warning email.
 */
import { CalendarClock } from 'lucide-react';

const WARN_DAYS = 14;

export function ConsentCountdown({ days }: { days: number | null }) {
  if (days == null) return null;

  const urgent = days <= WARN_DAYS;
  const label =
    days <= 0 ? 'Zustimmung abgelaufen' : `läuft in ${days} ${days === 1 ? 'Tag' : 'Tagen'} ab`;

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium ${
        urgent ? 'text-rose-600 dark:text-rose-400' : 'text-slate-500 dark:text-slate-400'
      }`}
    >
      <CalendarClock className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}
